import { MdOutlineEdit, MdDeleteOutline } from "react-icons/md";
import { DropdownItemProps } from "./dropdown-menu/DropdownItem";
import { AnimatePresence } from "framer-motion";
import DropdownMenu from "./dropdown-menu";

interface EditDeleteMenuProps {
  show: boolean;
  includeEdit?: boolean;
  includeDelete?: boolean;
  handleEdit: (event: React.MouseEvent) => void;
  handleDelete: (event: React.MouseEvent) => void;
  containerStyle: string;
}

const EditDeleteMenu: React.FC<EditDeleteMenuProps> = ({
  show,
  includeEdit = true,
  includeDelete = true,
  handleEdit,
  handleDelete,
  containerStyle
}) => {
  /**
   * Defining the options for the create button dropdown list
   */
  const optionsMenu: DropdownItemProps[] = [
    ...(includeEdit ? [{
      text: "Edit",
      icon: <MdOutlineEdit className="w-full h-full" />,
      onClickFunction: handleEdit,
    }] : []),
    ...(includeDelete ? [{
      text: <span className="text-error-600">Delete</span>,
      icon: <MdDeleteOutline className="w-full h-full fill-error-600" />,
      onClickFunction: handleDelete,
    }] : []),
  ];

  return (
    <AnimatePresence>
      {show && (
        <DropdownMenu
          containerStyle={containerStyle}
          optionsList={optionsMenu}
          variants={{
            initial: { opacity: 0, y: -20 },
            animate: {
              opacity: 1,
              y: 0,
              transition: { duration: 0.3, ease: "easeOut" },
            },
            exit: {
              opacity: 0,
              y: -20,
              transition: { duration: 0.3, ease: "easeOut" },
            },
          }}
        />
      )}
    </AnimatePresence>
  );
};

export default EditDeleteMenu;
